import React, { Component } from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  children: PropTypes.node,
}

const defaultProps = {}

class Footer extends Component {
  render() {
    const dt = new Date()

    return (
      <React.Fragment>
        <span>
          <a href="http://securelabx.com">Secure Lab X</a> {dt.getFullYear()}
          <code className="ml-2">Ver. {process.env.REACT_APP_GEP_VERSION}</code>
        </span>
        <span className="ml-auto">
          Powered by <a href="https://www.facebook.com/tess.utm/">IoT-Wave</a>
          &copy;
        </span>
      </React.Fragment>
    )
  }
}

Footer.propTypes = propTypes
Footer.defaultProps = defaultProps

export default Footer
